import _ from 'lodash';
import { log, jwt_decode } from '@swiper/core';

export default function memberAuth( app ) {

  app.on( 'login', ( authResult, { connection } ) => {
    if ( ! ( connection && connection.member ) ) return;
    const member = connection.member;
    log.debug( 'LOGIN MEMBER', member );
    connection.join( _.compact( [
      `members`,
      member.is_admin && 'admins',
      member.is_staff && 'staff',
      `members/${member.id}`,
    ] ) );
  } );

  app.on( 'logout', ( payload, { connection } ) => {
    if ( ! ( connection && connection.member ) ) return;
    const member = connection.member;
    log.debug( 'LOGOUT MEMBER', member );
    connection.leave( [
      `members`,
      'admins',
      'staff',
      `members/${member.id}`,
    ] );
  } );
}
